import { ApolloClient, ApolloLink, InMemoryCache } from '@apollo/client';
import { getApolloClientLink } from 'core/services/apollo/getApolloClientLink';

const createClient = (link: ApolloLink) => {
  return new ApolloClient({
    link,
    cache: new InMemoryCache({
      addTypename: false
    }),
    defaultOptions: {
      query: {
        fetchPolicy: 'network-only'
      },
      watchQuery: {
        fetchPolicy: 'network-only'
      },
      mutate: {
        fetchPolicy: 'network-only'
      }
    }
  });
};

export const createApolloClientForProvider = (organizationId: string) => {
  const apolloClientLink = getApolloClientLink(organizationId);
  return createClient(apolloClientLink);
};

export const createApolloClient = () => {
  const apolloClientLink = getApolloClientLink();
  return createClient(apolloClientLink);
};
